(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : global.GizmoSDK = factory();
})(this, function () {
  'use strict';

  var GizmoSDK =
  /** @class */
  function () {
    function GizmoSDK(container, options) {
      if (options === void 0) {
        options = {};
      }

      this._callbacks = {};
      this.contentWindow = container.contentWindow;
      this.targetOrigin = options.targetOrigin || "*";
      this.onMessage = this._onMessage.bind(this);
      window.addEventListener("message", this.onMessage, false);
    }

    GizmoSDK.prototype.dispatchEvent = function (parameters) {
      this.contentWindow.postMessage({
        method: "dispatchEvent",
        parameters: parameters
      }, this.targetOrigin);
    };

    GizmoSDK.prototype.start = function () {
      this.contentWindow.postMessage({
        method: "start"
      }, this.targetOrigin);
    };

    GizmoSDK.prototype.resize = function () {
      this.contentWindow.postMessage({
        method: "resize"
      }, this.targetOrigin);
    };

    GizmoSDK.prototype.getOptions = function (callback) {
      this.checkCallback(callback);
      var method = "getOptions";
      this.once(method, callback);
      this.contentWindow.postMessage({
        method: method
      }, this.targetOrigin);
    };

    GizmoSDK.prototype.getState = function (callback) {
      this.checkCallback(callback);
      var method = "getState";
      this.once(method, callback);
      this.contentWindow.postMessage({
        method: method
      }, this.targetOrigin);
    };

    GizmoSDK.prototype.setState = function (parameters, callback) {
      if (typeof callback !== 'function') {
        callback = function callback() {};
      }

      var method = "setState";
      this.once(method, callback);
      this.contentWindow.postMessage({
        method: method,
        parameters: parameters
      }, this.targetOrigin);
    };

    GizmoSDK.prototype.fire = function (event, data) {
      if (data === void 0) {
        data = null;
      }

      var callbacks = this._callbacks[event];
      var indices = [];
      if (callbacks === undefined) return;
      callbacks.forEach(function (handler, i) {
        handler.fn.call(handler.scope, data);

        if (handler.once) {
          indices.push(i);
        }
      });

      this._removeCallbacks(callbacks, indices);
    };

    GizmoSDK.prototype.on = function (event, callback, scope, once) {
      if (scope === void 0) {
        scope = this;
      }

      if (once === void 0) {
        once = false;
      }

      this.checkCallback(callback);

      if (this._callbacks[event] === undefined) {
        this._callbacks[event] = [];
      }

      this._callbacks[event].push({
        fn: callback,
        scope: scope,
        once: once
      });
    };

    GizmoSDK.prototype.once = function (event, callback, scope) {
      if (scope === void 0) {
        scope = this;
      }

      this.on(event, callback, scope, true);
    };

    GizmoSDK.prototype.off = function (event, callback, scope) {
      if (scope === void 0) {
        scope = this;
      }

      if (this._callbacks[event] === undefined) return;

      if (typeof callback !== "function") {
        this._callbacks[event].length = 0;
      }

      var callbacks = this._callbacks[event];
      var indices = [];

      for (var i = 0; i < callbacks.length; i++) {
        var handler = callbacks[i];

        if (handler.fn === callback && handler.scope === scope) {
          indices.push(i);
        }
      }

      this._removeCallbacks(callbacks, indices);
    };

    GizmoSDK.prototype.destroy = function () {
      window.removeEventListener("message", this.onMessage, false);
      this.contentWindow = null;
      this.onMessage = null;
    };

    GizmoSDK.prototype.checkCallback = function (callback) {
      if (typeof callback !== "function") {
        throw new Error("Callback must be a function.");
      }
    };

    GizmoSDK.prototype._onMessage = function (event) {
      if (!event.data) return;
      var evt = event.data.event || event.data.method;
      var data = event.data.data;

      if (evt) {
        this.fire(evt, data);
      }
    };

    GizmoSDK.prototype._removeCallbacks = function (callbacks, indices) {
      indices.forEach(function (index, i) {
        callbacks.splice(index - i, 1);
      });
    };

    return GizmoSDK;
  }();

  return GizmoSDK;
});